import { DHTOvertimeResponse } from '../../types/Drivers';
import useGetDHTCounterPerDriver from './useGetDHTCounterPerDriver';
import useGetDHTLimitsPerFleet from './useGetDHTLimitsPerFleet';
import useGetDHTLimitsPerDriver from './useGetDHTLimitsPerDriver';

function useGetDHTOvertimePerDriver(fleetId: string, driver: string): DHTOvertimeResponse {
  const { data: conters, status: getCounterStatus } = useGetDHTCounterPerDriver(fleetId, driver);
  const { data: fleetLimits, status: getFleetLimitStatus } = useGetDHTLimitsPerFleet(fleetId);
  const { data: driverLimits, status: getDriverLimitStatus } = useGetDHTLimitsPerDriver(fleetId, driver);

  const getOvertime = (conter?: number, driverLimit?: number, fleetLimit?: number): number => {
    let result = 0;
    if (conter && driverLimit) {
      result = conter - driverLimit;
    } else if (conter && fleetLimit) {
      result = conter - fleetLimit;
    } else if (conter) {
      result = 0;
    } else {
      result = 0;
    }
    return result;
  };

  return {
    tripInSec: getOvertime(conters?.tripInSec, driverLimits?.limitTripInSec, fleetLimits?.limitTripInSec),
    dayInSec: getOvertime(conters?.dayInSec, driverLimits?.limitDayInSec, fleetLimits?.limitDayInSec),
    weekInSec: getOvertime(conters?.weekInSec, driverLimits?.limitWeekInSec, fleetLimits?.limitWeekInSec),
    monthInSec: getOvertime(conters?.monthInSec, driverLimits?.limitMonthInSec, fleetLimits?.limitMonthInSec),
  };
}

export default useGetDHTOvertimePerDriver;
